// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-exclamation-point.js';

import { paths } from '../generated/file-exclamation-point';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-exclamation-point', Original, paths);
